var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCifsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5498e0",
    fillRule: "evenodd",
    d: "M47 19v7.467H15V19zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279c5",
    fillRule: "evenodd",
    d: "M47 27v7.467H15V27zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163f68",
    d: "M6.227-4.025a2.118 2.118 0 0 1-.835 1.771 3.712 3.712 0 0 1-2.324.647 5.607 5.607 0 0 1-2.426-.5v-1.635a10.209 10.209 0 0 0 1.468.528 4.476 4.476 0 0 0 1.1.153 1.6 1.6 0 0 0 .917-.221.749.749 0 0 0 .319-.658.711.711 0 0 0-.141-.434 1.556 1.556 0 0 0-.413-.366 10.749 10.749 0 0 0-1.11-.56A5.3 5.3 0 0 1 1.6-5.989a2.593 2.593 0 0 1-.627-.766 2.129 2.129 0 0 1-.231-1.022 2.115 2.115 0 0 1 .771-1.731 3.273 3.273 0 0 1 2.13-.63 5.186 5.186 0 0 1 1.275.153 8.955 8.955 0 0 1 1.269.431L5.6-8.185a8.767 8.767 0 0 0-1.134-.38 3.763 3.763 0 0 0-.882-.108 1.194 1.194 0 0 0-.791.233.757.757 0 0 0-.275.607.734.734 0 0 0 .111.406 1.206 1.206 0 0 0 .355.335 11.09 11.09 0 0 0 1.152.582A4.581 4.581 0 0 1 5.782-5.4a2.13 2.13 0 0 1 .445 1.375zm5.181 2.3L9.345-8.231h-.053Q9.4-6.244 9.4-5.58v3.859H7.78v-8.3h2.473l2.028 6.345h.035l2.151-6.345h2.473v8.3h-1.693v-3.928q0-.278.009-.641t.079-1.93h-.053l-2.209 6.5zm7.689-8.3h2.666a5.28 5.28 0 0 1 2.646.5 1.732 1.732 0 0 1 .823 1.6 1.968 1.968 0 0 1-.36 1.22 1.447 1.447 0 0 1-.958.573v.057a1.9 1.9 0 0 1 1.175.658 2.092 2.092 0 0 1 .36 1.283 2.088 2.088 0 0 1-.849 1.777 3.748 3.748 0 0 1-2.3.636h-3.2zm1.817 3.286h1.055a1.98 1.98 0 0 0 1.07-.221.815.815 0 0 0 .331-.732.727.727 0 0 0-.36-.684 2.381 2.381 0 0 0-1.14-.207h-.955zm0 1.4v2.162H22.1a1.8 1.8 0 0 0 1.1-.275 1.011 1.011 0 0 0 .357-.851q0-1.033-1.524-1.033z",
    transform: "translate(19.357 50.998)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCifsDefault);
export default __webpack_public_path__ + "static/media/cifs-default.d3d2b0576c0d58a4c08e1f0af3657c84.svg";
export { ForwardRef as ReactComponent };